
<template>

<div class="spinner">
  <van-loading type="spinner" color="#01458c" size="25px" />
</div>

      
</template>

<script>

export default {
 
}
</script>

<style scoped>
.spinner .color-load
  {
  color:rgba(1, 69, 140, 1.000);

}

/* Absolute Center Spinner */
.spinner {
  z-index: 999;
  overflow: show;
  margin: auto;
  width: 50px;
  height: 50px;
}

</style>